var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"main-panel w-100",staticStyle:{"float":"none"}},[_c('top-navbar'),_c('dashboard-content')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }